module.exports = __webpack_public_path__ + "img/enterprise1.4e8a8922.png";